import { Text } from '@connect-x-app/hybrid-ui';
import { IconName } from '@connect-x-app/shared-types';
import { COLORS } from '@connect-x-app/shared-ui';
import { PROFILE_TEST_IDS } from '@connect-x-app/web-test-ids';

import { Icon } from '../icon';

import './profileHeader.scss';

type Props = {
  firstName?: string | null;
  iconName: IconName;
  jobTitle: string;
  lastName?: string | null;
};

export const ProfileHeader = ({ firstName, iconName, jobTitle, lastName }: Props) => {
  return (
    <header className="profile-section-top-container">
      <div className="profile-section-top-body">
        <div className="profile-icon-container">
          <Icon colorName={COLORS.yuma.$01} name={iconName} size={5} />
        </div>
        <Text color={COLORS.zulu.$08} size="MD" testID={PROFILE_TEST_IDS.header.username} weight="semiBold">
          {lastName ? `${firstName} ${lastName}` : firstName}
        </Text>
        <Text color={COLORS.romeo.$07} size="MD" testID={PROFILE_TEST_IDS.header.jobTitle} uppercase weight="bold">
          {jobTitle}
        </Text>
      </div>
    </header>
  );
};
